module.exports = __webpack_public_path__ + "img/logo-pjlm - 副本.png";